import {
  useListSource,
  DictionaryAutocomplete,
  useStaticListSource,
} from '@eas/common-web';
import { Activity, Program } from '../../common/models';
import { useTicketListSource } from '../../common/use-ticket-list-source';

export function useOrganisationTypes() {
  return useListSource<DictionaryAutocomplete>({
    url: '/api/ks/public/dictionary/organisation-types/all',
  });
}

export function useProjectPhases() {
  return useListSource<DictionaryAutocomplete>({
    url: '/api/ks/public/dictionary/project-phases/all',
  });
}

export function useRegions() {
  return useListSource<DictionaryAutocomplete>({
    url: '/api/ks/public/dictionary/regions/all',
  });
}

export function usePrograms() {
  return useListSource<DictionaryAutocomplete>({
    url: '/api/ks/public/dictionary/programs/all',
  });
}

export function useSpecificTargets() {
  return useListSource<DictionaryAutocomplete>({
    url: '/api/ks/public/dictionary/specific-targets/all',
  });
}

export function useTicketSpecificTargets(program?: Program) {
  return useTicketListSource<DictionaryAutocomplete>({
    url:
      program != null
        ? `/api/ks/public/dictionary/specific-targets/all?programIds=${encodeURIComponent(
            program.id
          )}`
        : '/api/ks/public/dictionary/specific-targets/all',
    skip: program == null,
  });
}

export function useNotices(activity?: Activity) {
  return useListSource<DictionaryAutocomplete>({
    url:
      activity != null
        ? `/api/ks/public/dictionary/notices/all/activity/${activity.id}`
        : '/api/ks/public/dictionary/notices/all',
    apiUrl: '/api/ks/public/dictionary/notices',
  });
}

export function useTicketNotices(
  activity?: Activity,
  specificTargetIds: string[] = []
) {
  const specificTargetQuery = specificTargetIds
    .map((id) => `specificTargetIds=${encodeURIComponent(id)}`)
    .join('&');
  return useTicketListSource<DictionaryAutocomplete>({
    url:
      activity != null && specificTargetQuery !== ''
        ? `/api/ks/public/dictionary/notices/all/activity/${encodeURIComponent(
            activity.id
          )}?${specificTargetQuery}`
        : '/api/ks/public/dictionary/notices/all',
    apiUrl: '/api/ks/public/dictionary/notices',
    skip: activity == null || specificTargetIds.length === 0,
  });
}

export function useActivities() {
  return useListSource<DictionaryAutocomplete>({
    url: '/api/ks/public/dictionary/activities/all',
  });
}

export function useTicketActivities(program?: Program) {
  return useTicketListSource<DictionaryAutocomplete>({
    url:
      program != null
        ? `/api/ks/public/dictionary/activities/all?programIds=${encodeURIComponent(
            program.id
          )}`
        : '/api/ks/public/dictionary/activities/all',
    skip: program == null,
  });
}

export function useTicketStates() {
  return useStaticListSource<DictionaryAutocomplete>([
    { id: 'NEW', name: 'Nový' },
    { id: 'PROCESSING', name: 'V řešení' },
    { id: 'RESOLVED', name: 'Zodpovězen' },
    { id: 'RETURNED', name: 'Vrácen k doplnění' },
  ]);
}
